<template>
    <div>
        <div class="columns">
            <div class="column is-3">
                <h2 class="title is-3 between-center">
                    <span>
                        <span>Timelogs</span>
                        <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                            <o-icon pack="fa" icon="gear" size="is-small" />
                        </a>
                    </span>
                </h2>
            </div>
            <div class="column">
                <div class="field is-grouped is-pulled-right">
                    <p v-if="isDeleteSelectedButtonVisible" class="control">
                        <a @click.prevent="confirmCustomDelete" class="button is-danger is-small">Delete selected</a>
                    </p>
                    <p class="control">
                        <a @click.prevent="openGlobalTimelog({project_id: currentProjectId})" class="button is-info">New</a>
                    </p>
                </div>
            </div>
        </div>
        <o-table
            class="project-width-table is-responsive is-responsive-desktop"

            v-if="isTableVisible"
            :data="timelogsByProjectId(currentProjectId)"

            :bordered="table.bordered"
            :striped="table.striped"
            :narrowed="table.narrowed"
            :checkable="table.checkable"
            :mobile-cards="table.mobileCards"
            :paginated="table.paginated"
            :pagination-simple="table.paginationSimple"
            :per-page="table.perPage"
            :default-sort-direction="table.defaultSortDirection"
            :default-sort="['date', 'desc']"
            :selected.sync="selected"
            :checked-rows="checkedRows"
            @update:checkedRows="$event => checkedRows = $event"

            :loading="loading"
            :total="total"
        >
            <template>
                <template v-for="col in tableColumns" :key="col.field">
                    <o-table-column
                        :field="col.field"
                        :label="col.field === 'actions' ? '' : col.label"
                        #default="{ row }"
                        :sortable="col.sortable"
                    >
                        <router-link v-if="col.field === 'user_id'" :to="{ name: 'users.show', params: { slug: row.user_id } }">
                            {{ $filters.valueOrDefault(userNameById(row.user_id), '–') }}
                        </router-link>
                        <router-link v-if="col.field === 'project_id'" :to="{ name: 'projects.show', params: { slug: row.project_id } }">
                            {{ $filters.valueOrDefault(projectNameById(row.project_id), '–') }}
                        </router-link>

                        <span v-if="col.field === 'client'">{{ $filters.valueOrDefault(row.company_name, '-') }}</span>
                        <span v-if="col.field === 'focus'">{{ timelogActivityName(row) }}</span>
                        <span v-if="col.field === 'time'">{{ row.time }}</span>
                        <span v-if="col.field === 'note'" v-html="row.note"></span>
                        <span v-if="col.field === 'activity_type'">{{ row.activity_type }}</span>
                        <span v-if="col.field === 'activity'">{{ $filters.valueOrDefault(dictionaryEntryNameByTypeAndId('timelog-activity', row.activity_name)) }}</span>
                        <span v-if="col.field === 'date'">{{ $filters.date(row.date) }}</span>
                        <span v-if="col.field === 'created_at'">{{ $filters.date(row.created_at) }}</span>
                        <span v-if="col.field === 'last_editor_id'">{{ userNameById(row.last_editor_id) }}</span>
                        <o-dropdown v-if="col.field === 'actions'" hoverable position="bottom-left" class="table-actions">
                          <template #trigger>
                            <button class="button">
                              <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                            </button>
                          </template>
                            <o-dropdown-item has-link><a @click="openTimeLogModal(row)">View</a></o-dropdown-item>
                        </o-dropdown>
                        <span v-if="col.field === 'hourly_rate'">{{ $filters.currency(row.hourly_rate) }}</span>
                        <span v-if="col.field === 'cost'">{{ $filters.currency(row.cost) }}</span>
                    </o-table-column>
                </template>
            </template>

          <template #empty>
            <div class="has-text-centered">
              This table is empty!
            </div>
          </template>
        </o-table>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTimeLogModalActive" has-modal-card>
            <time-log-modal :timelog-prop="timelog" :project-id="currentProjectId" />
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Table from './../../../mixins/Table'

    export default {
        mixins: [Table],

        data() {
            return {
                tableName: 'timelogs-index',
                timelog: null,
                isTimeLogModalActive: false,
                filters: {
                    project_id: null
                }
            }
        },

        mounted() {
            this.fetchData({project_id: this.currentProjectId})
        },

        computed: {
            ...mapGetters([
                'timelogsByProjectId',
                'currentProjectId',
                'timelogActivityName',
                'projectNameById', 'projectById', 'userNameById',
                'dictionaryEntryNameByTypeAndId',
            ]),

            ...mapGetters({
                itemsByIds: 'timelogsByIds',
                userNameById: 'userNameById',
                projectById: 'projectById',
            })
        },

        methods: {
            ...mapActions({
                fetchData: 'fetchTimelogs',
                removeItem: 'removeTimelog'
            }),

            ...mapActions(['openGlobalTimelog']),

            openTimeLogModal(timeLog) {
                this.isTimeLogModalActive = true
                this.timelog = timeLog
            },
        },
    }
</script>
